module.exports = __webpack_public_path__ + "img/مونوگرام1.45f417b6.png";